/**
 * Application main entry point.
 */
import React from "react";
import ReactDOM from "react-dom";

import getContext from "@utils/context";
import App from "./App";

// Set the api domain so we know where to send API requests.
window.serverContext = {};

// NOTE(patrick): Pre-emptively fetch the server context for the buyflow. This
// improves page load performance by having serverContext ready by the time the
// React application loads.
window.serverContextLoaded = getContext();

// Render our application.
function main(err) {
  if (err && err instanceof Error) {
    console.error("[TODO][main]:", err);
  }
  ReactDOM.render(React.createElement(App), document.getElementById("root"));
}

function loadScript(src, done) {
  const js = document.createElement("script");
  js.src = src;
  js.onload = done;
  js.onerror = function() {
    console.log("~> onerror", arguments);
    done(new Error(`Failed to load script ${src}`));
  };
  document.head.appendChild(js);
}

if (window.Promise && window.fetch && window.URL) {
  main();
} else {
  // loadScript('/polyfills.js', main);
  import("./polyfills.js").then(main, main);
}
